import "./scripts/scripts";
import "../css/custom.css";

global.jQuery = require('jquery');
var jQBridget = require('jquery-bridget');
var Isotope = require('isotope-layout');
var imagesLoaded = require('imagesloaded');

var slick =  require('slick-carousel');
var fancybox =  require('@fancyapps/fancybox');
jQBridget('isotope', Isotope);


jQuery(function() {
	initSlickCarousel();
	initFancybox();
	initFilter();
});

function initSlickCarousel() {
	jQuery('.slider').slick({
		slidesToScroll: 1,
		rows: 0,
		arrows: true,
		adaptiveHeight: true,
		prevArrow: '<button class="slick-prev"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path fill="#FFFFFF" d="M12.444 27.556c-0.178 0-0.533 0-0.711-0.178l-10.667-10.667c0 0 0 0 0 0v0c0 0 0 0 0 0v0c0 0-0.178-0.178-0.178-0.356s0-0.178 0-0.356v0c0 0 0 0 0 0s0 0 0 0v0c0 0 0 0 0 0s0 0 0 0v0c0 0 0 0 0 0s0 0 0 0v0c0-0.178 0-0.178 0-0.356s0.178-0.178 0.178-0.356v0c0 0 0 0 0 0v0c0 0 0 0 0 0l10.667-10.667c0.356-0.356 0.889-0.356 1.244 0s0.356 0.889 0 1.244l-9.067 9.244h26.311c0.533 0 0.889 0.356 0.889 0.889s-0.356 0.889-0.889 0.889h-26.311l9.067 9.067c0.356 0.356 0.356 0.889 0 1.244 0 0.356-0.356 0.356-0.533 0.356z"></path></svg></button>',
		nextArrow: '<button class="slick-next"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path fill="#FFFFFF" d="M19.556 27.556c-0.178 0-0.533 0-0.711-0.178-0.356-0.356-0.356-0.889 0-1.244l9.067-9.067h-26.133c-0.533-0.178-0.889-0.533-0.889-1.067s0.356-0.889 0.889-0.889h26.311l-9.067-9.067c-0.356-0.356-0.356-0.889 0-1.244s0.889-0.356 1.244 0l10.667 10.667c0 0 0 0 0 0v0c0 0 0 0 0 0v0 0c0 0 0.178 0.178 0.178 0.356s0 0.178 0 0.356v0c0 0 0 0 0 0s0 0 0 0v0c0 0 0 0 0 0s0 0 0 0v0c0 0 0 0 0 0s0 0 0 0v0c0 0.178 0 0.178 0 0.356s-0.178 0.178-0.178 0.356v0 0c0 0 0 0 0 0v0c0 0 0 0 0 0l-10.667 10.667c-0.178 0-0.533 0-0.711 0z"></path></svg></button>'
	});
}

// lightbox init
function initFancybox() {
	jQuery('a.lightbox, [data-fancybox]').fancybox({
		parentEl: 'body',
		buttons: [
		"close"
		],
		margin: [50, 0]
	});
}


function initFilter() {
	var $container = jQuery('.filter-container');
	$container.imagesLoaded(function() {
		$container.isotope({
			itemSelector: '.brick',
			layoutMode: 'fitRows'
		});
	});
	
	if (location.hash.length && location.hash.replace(/_/g, ' ').slice(1) != 'all') {
		
		
		jQuery('.filter-list').find('a').each(function() {
			if (jQuery(this).data('filter') == location.hash.replace(/_/g, ' ').slice(1)) {
				jQuery(this).addClass('active').siblings().removeClass('active');
			}
		});
		
		$container.isotope({
			filter: '[data-filter*=' + location.hash.replace(/_/g, ' ').slice(1) + ']'
		});
	}
	
	jQuery('.filter-list').each(function() {
		var holder = jQuery(this);
		
		
		holder.find('a').on('click', function(e) {
			e.preventDefault();
			var parent = jQuery(this);
			parent.addClass('active').siblings().removeClass('active');
			
			if (holder.hasClass('active')) {
				holder.removeClass('active');
			}
			
			var filter = jQuery(this).data('filter');
			$container.isotope({ filter: filter === 'all' ? '*' : '[data-filter*=' + filter + ']' });
			var f = filter.replace(/\s/g, '_');
			
			if (location) {
				location.hash = f;
			}
		});
		
		
		// jQuery(window).on('click', function(e) {
		// 	if (!drop.is(e.target) && drop.has(e.target).length === 0 && !opener.is(e.target) && opener.has(e.target).length === 0) {
		// 		if (holder.hasClass('active')) {
		// 			holder.removeClass('active');
		// 		}
		// 	}
		// });
	});
}